import Utils from "../Utils";
import { AuthAxios } from "./AxiosInstances";

const GetHeaders = () => {
    return { headers : { Authorization : 'Bearer ' + Utils.GetUser().token }}
}

const GetOrder = (id) => {
    return AuthAxios.get(`order/${id}`, GetHeaders());
}

const GetMyOrders = (page = 1) => {
    return AuthAxios.get(`order/myorders?page=${page}`, GetHeaders())   
}

const CancelOrder = (id) => {
    return AuthAxios.put(`order/${id}/cancel`, null, GetHeaders())
}

const RequestCode = (orderId, productId) => {
    return AuthAxios.post(`order/${orderId}/redeem?product=${productId}`, null, GetHeaders())
}

const PayOrder = (orderId) => {
    return AuthAxios.post(`order/${orderId}/pay`, null, GetHeaders());
}

const Checkout = (order) => {
    return AuthAxios.post(`order/checkout`, order, GetHeaders())
}

const OrderAPI = {
    GetOrder,
    GetMyOrders,
    CancelOrder,
    RequestCode,
    PayOrder,
    Checkout
}

export default OrderAPI;